import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import { AwaitIterators } from '../AnimationHelper';
import TransformComponent from '../../../Component/Transform';
import TextComponent from '../../../Component/Render/Text';

export class TextPopOut extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform = gameObject.getComponent(TransformComponent);
        const textComponent = gameObject.getComponent(TextComponent);

        textComponent.alpha = 1;
        transform.scale.set(1, 1);

        const scaleTween = this.getTween(transform.scale);
        const alphaTween = this.getTween(textComponent);

        alphaTween.to({ alpha: 0 }, 150).easing(Easing.Linear.None);
        scaleTween.to({ x: 0, y: 0 }, 600).easing(Easing.Elastic.Out);

        yield* AwaitIterators([
            this.startTween(scaleTween),
            this.startTween(alphaTween),
        ]);
    }
}
